// 最近列表
import React, { useContext, useState, useEffect, useCallback } from "react";
import api from "../../api";
import contextMenus, { Names } from "../../contextMenus";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import events from "../../context/events";
import TableList from "../../components/TableList";
import { ColumnsItem, JustifyContent } from "../../components/TableList/BaseComponents/Header";
import {
  createJoyspcFolderData,
  getFilePath,
  getFullPathByForomId,
  getIconUrl,
  openLink,
  partialRefresh,
  time
} from "../../util";
import { changeEgovUrl } from "@/utils/tools";
import { message, Tooltip } from "antd";
import ContextMenu from "../../components/List/ContextMenu";
import Tags, { TagType } from "../../components/Tags";
import openDeleteModal from "../../contextModal/DeleteModal";
import openErrorDeleteModal from "../../contextModal/ErrorDeleteModal";
import { pageSize } from "../../config/basics.config";
import { SyncStatusEunm } from "@/components/Joyspace/controllers/JoyspaceController";
import { ActionFnEnum, ContextMenuMode, FileType, MenusType } from "../../types";
import { useHistory } from "react-router-dom";
import UpdataService from "../../reloadUtils";
import context from "../../context";
import { addJoysapceMap } from "../../api/permissions";
import { joyspacePermissionType } from "../../config/permissions.config";
import { useNavigator } from "@/utils/NetworkCheck";
import SyncStatusTag from "../../components/SyncStatusTag";
import { analysisLog } from "@/utils/logAnalytics";
import { useListData } from "../../components/TableList/Use/useListData";
import Filters from "../../components/List/Filters";
import { PageRouteName } from "../../batchOperate";
import { Order, Sort, recentTimeFilter } from "../../components/List/Filters/config";

const format = (item: any) => {
  item.title = item.title || "无标题";
  item.isNew && useNavigator.onLine && (item.isDisabled = true);
  if (item.kl_type) {
    item.fullName = "知识库：" + item.space_name;
  } else {
    item.fullName = item?.full_name ? item?.full_name.replace(/\$@\$/g, "/") : "/";
  }
  item.path = getFilePath(item.spaceType, getFullPathByForomId(item?.full_path));
  return item;
};
const key = MenusType.RECENT;
// 获取数据
const getList = (params: any) => {
  return new Promise((resolve, reject) => {
    api.pages
      .recent(params)
      .then((res) => {
        if (res) {
          res.pages = (res.pages || []).map((item: any) => {
            format(item);
            return { ...item };
          });
        }
        resolve(res);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
let defaultFilterInfo = { order: Order.DESC, sort: Sort.OpenTime };
export default function (props: any) {
  const globalContext = useContext<GlobalContextConfig>(GlobalContext);
  const { addFolderInfo } = useContext(context);
  const [filterInfo, setFilterInfo] = useState(defaultFilterInfo);
  const history = useHistory();
  const [columns, setColumns] = useState([
    { title: "标题", key: "title", dataIndex: "title", ellipsis: true },
    {
      title: "文件所在位置",
      key: "fullName",
      dataIndex: "fullName",
      ellipsis: true
    },
    {
      title: "",
      key: "time",
      dataIndex: "time",
      width: "20%",
      style: {
        minWidth: "142px"
      },
      justifyContent: JustifyContent.Left,
      filters: true,
      render: () => (
        <Filters
          from={PageRouteName.RECENT}
          menu={recentTimeFilter()}
          defaultFilterInfo={filterInfo}
          callback={(order: Order, sort: Sort) => {
            setFilterInfo({ order, sort });
            defaultFilterInfo.order = order;
            defaultFilterInfo.sort = sort;
          }}
        />
      )
    },
    {
      title: "",
      key: "actions",
      dataIndex: "actions",
      actions: true,
      width: "10%",
      style: {
        minWidth: "30px"
      },
      justifyContent: JustifyContent.Center
    }
  ]);
  const {
    list,
    setList,
    total,
    setTotal,
    loading,
    isLoadMore,
    setLoadMore,
    onButtom,
    setPageIndex,
    pageIndex
  } = useListData({
    defaultFilterInfo: filterInfo,
    requestPagesFunc: getList,
    isEmitLoadMore: true,
    isFilter: true,
    isCategory: false,
    key
  });

  useEffect(() => {
    events.on("joyspace:onButtom", onButtom);
    return () => {
      events.off("joyspace:onButtom", onButtom);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onButtom]);

  const openPage = async (columnsItem: ColumnsItem, item: any) => {
    if (columnsItem.key === "fullName" && columnsItem.dataIndex === "fullName") {
      if (item.fullName === "/" || item.kl_type) {
        return;
      }
      //   const res: any = await addJoysapceMap(item.space_category_id, item, addFolderInfo);
      const path = item.path;
      //    const path=  res !== joyspacePermissionType.ReadDel
      //       ? getFilePath(res.type, item.space_category_id)
      //       : item.path;
      analysisLog("xtbg_joyspace_file_location", "click", "RECENT", path);
      history.push(path);
      return;
    }
    if (!item.status && useNavigator.onLine) {
      openDeleteModal(FileType.Page, item.id);
      return;
    }
    if (item.syncStatus === SyncStatusEunm.PROCESS) {
      message.error("文档同步中，请同步完成后查看");
      return;
    }
    if (item.syncStatus === SyncStatusEunm.DATAERROR) {
      openErrorDeleteModal(item);
      return;
    }
    if (columnsItem.key === "title") {
      openLink(item, globalContext.appRuntimeEnv.joyspaceHost);
    }
  };
  const getTips = (columnsItem: ColumnsItem, item: any) => {
    if (columnsItem.key === "fullName" && columnsItem.dataIndex === "fullName") {
      if ((item as any)[columnsItem.dataIndex] === "/") {
        return "文件所属文件夹未分享，暂不可获取文件位置";
      }
    }
    return columnsItem.ellipsis ? (item as any)[columnsItem.dataIndex] : "";
  };
  const className = useCallback((columnsItem: ColumnsItem, value = "/") => {
    if (columnsItem.key === "title") {
      return "joyspace-list-title joyspace-list-ellipsis";
    } else if (columnsItem.key === "fullName" || columnsItem.ellipsis) {
      const names = "joyspace-list-text joyspace-list-ellipsis";
      if (columnsItem.dataIndex === "fullName" && (value === "/" || value.includes("知识库"))) {
        return `${names} joyspace-list-path-disabled`;
      }
      return columnsItem.key === "fullName" ? `joyspace-list-path ${names}` : names;
    } else {
      return "joyspace-list-text";
    }
  }, []);
  return (
    <div className="joyspace-list-table">
      <TableList
        isLoadMore={isLoadMore}
        columns={columns}
        from={Names.RECENT}
        list={list}
        loading={loading}
        pagination={false}
        folderFrom={{ draggerUploadShow: true }}
        isDataText={defaultFilterInfo.sort !== Sort.ModifiedTime}
        renderActions={(item: any, contextMenuMode = ContextMenuMode.Click) => {
          return (
            <ContextMenu
              render={contextMenus.page(Names.RECENT, globalContext)}
              callbackProps={{
                contextMenuMode,
                data: item,
                originId: "",
                setData: (data: any) => {
                  events.emit("list.partial.refresh", {
                    changeData: data,
                    key
                  });
                },
                remove: () => {
                  console.log("remove");
                },
                reload: () => {
                  console.log("reload");
                }
              }}
            />
          );
        }}
        preOptions={(item, data, isExist) => {
          return (
            item.dataIndex === "title" && (
              <img
                src={
                  !isExist ? changeEgovUrl(data.icon_url) : getIconUrl(data.type || data.page_type)
                }
                data-icon
              />
            )
          );
        }}
        afterOptions={(item, data) => {
          return (
            item.dataIndex === "title" &&
            data.isCollected && <Tags left={5} TagType={TagType.Follow} />
          );
        }}
        onButtom={onButtom}
        handleItem={openPage}
        contentRender={(columnsItem: ColumnsItem, item: any) => {
          if (columnsItem.dataIndex === "time" && item.isNew) {
            return <SyncStatusTag status={item.syncStatus} />;
          }
          return (
            <Tooltip placement="top" title={getTips(columnsItem, item)}>
              <span
                className={className(columnsItem, (item as any)[columnsItem.dataIndex])}
                onClick={() => {
                  openPage?.(columnsItem, item);
                }}
              >
                {(item as any)[columnsItem.dataIndex]}
              </span>
            </Tooltip>
          );
        }}
      />
    </div>
  );
}
